module.exports = __webpack_public_path__ + "media/images/icon__copy-to-clipboard-3c3bf3809f2ceb22c2639c7e74344e10.png";